import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './TestimonialLegacy.module.scss';

/**
 * TODO: This is a legacy page section type that should be phased out
 *
 * @param logo
 * @param logoClass
 * @param body
 * @param attribution
 * @param pClassName
 * @returns {JSX.Element}
 * @constructor
 */
const TestimonialLegacy = ({ logo, logoClass, body, attribution, pClassName = '' }) => {
  let image = <img src={get(logo, 'file.url')} alt={logo.title} />;
  if (logo.file.contentType !== 'image/svg+xml' && !!logo.gatsbyImageData) {
    image = <GatsbyImage alt={logo.title} image={logo.gatsbyImageData} />;
  }
  return (
    <div className={styles.container}>
      <div className={[styles.logo, logoClass].join(' ')}>{image}</div>
      <div className={styles.copy}>
        <p className={pClassName}>{typeof body !== 'string' ? <RichTextConverter copy={body} /> : body}</p>
        {attribution && (
          <p className={styles.attribution}>
            <span>_</span>
            {attribution}
          </p>
        )}
      </div>
    </div>
  );
};

TestimonialLegacy.propTypes = {
  logo: PropTypes.object.isRequired,
  body: PropTypes.string.isRequired,
  logoClass: PropTypes.string,
  pClassName: PropTypes.string,
};

export default TestimonialLegacy;
